import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import MessageItem from "@/components/community/MessageItem";

export default function ModerationPanel({ api }) {
  const [reports, setReports] = useState(null);
  const [members, setMembers] = useState(null);
  const load = useCallback(() => {
    api.get("/admin/community/reports").then(({ data }) => setReports(data.reports)).catch(() => setReports([]));
    api.get("/admin/community/members").then(({ data }) => setMembers(data.members)).catch(() => setMembers([]));
  }, [api]);
  useEffect(() => { load(); }, [load]);

  const run = async (fn, ok) => {
    try {
      await fn();
      toast.success(ok);
      load();
    } catch {
      toast.error("Something went wrong. Try again.");
    }
  };
  const btn = "min-h-[36px] px-3 border font-mono-label text-[10px] transition-colors";

  return (
    <div className="grid lg:grid-cols-2 gap-6" data-testid="community-moderation">
      <section className="brutal-border p-4">
        <div className="font-mono-label text-[10px] text-muted-foreground mb-3">REPORTED MESSAGES · {reports?.length ?? "…"}</div>
        {reports?.length === 0 && <p className="text-sm text-muted-foreground" data-testid="community-reports-empty">No open reports.</p>}
        {reports?.map((r) => (
          <div key={r.id} className="border border-[#262626] mb-3" data-testid={`community-report-${r.id}`}>
            <MessageItem api={api} msg={r.message} me={{ is_mod: true }} compact />
            <div className="px-3 pb-3 text-xs text-muted-foreground">
              Reported by {r.reporter.name || r.reporter.email || "a member"}{r.reason ? `: “${r.reason}”` : ""}
              <div className="mt-2 flex flex-wrap gap-2">
                <button className={`${btn} border-[#F87171] text-[#F87171]`} data-testid={`community-report-delete-${r.id}`}
                  onClick={() => run(() => api.delete(`/community/messages/${r.message.id}`), "Message deleted")}>Delete message</button>
                {!r.message.author_is_team && (
                  <button className={`${btn} border-[#262626] hover:border-white`} data-testid={`community-report-mute-${r.id}`}
                    onClick={() => run(() => api.post(`/admin/community/members/${r.message.author_uid}/status`, { status: "muted" }), "Author muted")}>Mute author</button>
                )}
                <button className={`${btn} border-[#262626] hover:border-white`} data-testid={`community-report-dismiss-${r.id}`}
                  onClick={() => run(() => api.post(`/admin/community/reports/${r.id}/dismiss`), "Report dismissed")}>Dismiss</button>
              </div>
            </div>
          </div>
        ))}
      </section>
      <section className="brutal-border p-4">
        <div className="font-mono-label text-[10px] text-muted-foreground mb-3">MUTED & REMOVED MEMBERS</div>
        {members?.length === 0 && <p className="text-sm text-muted-foreground" data-testid="community-members-empty">Everyone is in good standing.</p>}
        {members?.map((m) => (
          <div key={m.user_id} className="py-2 border-b border-[#262626] flex items-center justify-between gap-3" data-testid={`community-member-${m.user_id}`}>
            <div className="min-w-0">
              <div className="text-sm font-semibold truncate">{m.name || m.email}</div>
              <div className="text-xs text-muted-foreground truncate">{m.business} · <span className={m.status === "removed" ? "text-[#F87171]" : "text-[#FFD600]"}>{m.status}</span></div>
            </div>
            <button className={`${btn} border-[#262626] hover:border-white shrink-0`} data-testid={`community-member-restore-${m.user_id}`}
              onClick={() => run(() => api.post(`/admin/community/members/${m.user_id}/status`, { status: "active" }), "Member restored")}>Restore</button>
          </div>
        ))}
      </section>
    </div>
  );
}
